import React from "react";
import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
const movies = [{
  id: 1,
  title: "Programmazione e Realizzazione nuove Scuole",
  rating: "4K",
  quality: "VIDEO",
  type: "Intervento Integrale",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/borelli_video_piazza.png",
  video_url: "https://borellisindaco.it/wp-content/uploads/2026/05/FDownloader.Net_AQMNynoM1tH5UAPYWypmSbA1qZ4ZE-2nAGWHpwVyVdwyv2wHhUebG0LEJFOd5msBu7rSJ83DGF40w2z_-BjrVclpfxcJiu5MgvYiI2Hro75KLA_720p_HD.mp4"
}, {
  id: 2,
  title: "Il Piano per la Mobilità Sostenibile ad Albano",
  rating: "HD",
  quality: "VIDEO",
  type: "Sintesi Programma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/borelli_video_mobilita.png"
}, {
  id: 3,
  title: "Incontro con i Cittadini di Cecchina",
  rating: "HD",
  quality: "VIDEO",
  type: "Ascolto Attivo",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/borelli_video_cecchina.png"
}, {
  id: 4,
  title: "Video 4: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 5,
  title: "Video 5: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 6,
  title: "Video 6: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 7,
  title: "Video 7: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 8,
  title: "Video 8: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 9,
  title: "Video 9: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}, {
  id: 10,
  title: "Video 10: Comunicazione",
  rating: "HD",
  quality: "VIDEO",
  type: "Comunicazione",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/placeholder_video.png"
}];
export default function PopularMovies() {
  return <section data-section-id="242624" id="galleria-video" className="bg-background py-12 px-4 md:px-6 lg:px-8 text-foreground">
      <div className="mx-auto max-w-5xl">
        <div className="mb-6 flex justify-center">
          <div className="rounded-lg bg-accent px-6 py-1.5 text-sm font-medium text-accent-foreground shadow-sm">
            Albano Conta
          </div>
        </div>

        <div className="mb-8 rounded-lg border-l-4 border-secondary bg-primary px-4 py-3.5 text-center shadow-md">
          <h2 className="font-default text-xl font-bold text-primary-foreground sm:text-2xl">
            Comunicazione Istituzionale e Video
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {movies.map((movie, i) => <Link to="/VideoPage" key={movie.id} data-index={i} className="group block">
              <Card className="h-full overflow-hidden border-none bg-muted text-foreground shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:ring-1 hover:ring-primary hover:ring-offset-2 hover:ring-offset-background">
                <div className="relative aspect-square w-full overflow-hidden bg-muted">
                  {(movie as any).video_url ? <video src={(movie as any).video_url} controls autoPlay muted className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <img src={movie.image} alt={movie.title} data-wvc-srcset={`${movie.image}-wvc-srcset`} data-wvc-sizes={`${movie.image}-wvc-sizes`} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}

                  <div className="absolute left-0 top-0 flex items-center gap-1 rounded-lg bg-primary/90 px-2.5 py-1 text-sm font-semibold text-primary-foreground backdrop-blur-sm">
                    {movie.rating}
                    <Star className="h-3.5 w-3.5 fill-secondary text-secondary" />
                  </div>

                  <div className="absolute right-0 top-0 rounded-lg bg-secondary px-3 py-1 text-xs font-bold tracking-wider text-secondary-foreground shadow-sm">
                    {movie.quality}
                  </div>

                  </div>

                <CardContent className="p-4 text-center">
                  
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}